import styled, { css } from "styled-components"

interface ContainerProps {
  $removePaddingBottom?: boolean
}

interface StyledProps {
  $show?: boolean
  $invalid?: boolean
}

interface FallbackProps {
  $booleanValue?: boolean
}

export const Container = styled.div<ContainerProps>`
  padding-bottom: ${(p) => (p.$removePaddingBottom ? "0" : "2rem")};
  position: relative;
  width: 100%;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    padding-bottom: ${(p) => (p.$removePaddingBottom ? "0" : "2.4rem")};
  }

  input[type="file"]::-webkit-file-upload-button {
    border: none;
    padding: 0.5rem 1.2rem;
    background: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
    font-size: 1em;
    transition: all 0.2s;
    border-radius: 0.5rem;
    cursor: pointer;
    margin-right: 1rem;
    letter-spacing: 0.05rem;
  }
`

export const Field = styled.input<StyledProps>`
  width: 100%;
  height: 4.5rem;
  padding: 0.1rem 2rem 0;
  border: 0.1rem solid
    ${(p) => (p.$invalid ? p.theme.colors.error.background : p.theme.colors.greyLight)};
  border-radius: 0.5rem;
  transition: all 0.2s;
  box-shadow: 0 0 0.5rem 0 ${(p) => (!p.$invalid ? "transparent" : p.theme.colors.error.background)};

  &[type="file"] {
    background-color: field;
    line-height: 4rem;
  }

  ${(p) =>
    !p.$invalid &&
    css`
      &:focus {
        box-shadow: 0 0 0.5rem 0 ${(p) => p.theme.colors.turquoiseDark};
        border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
      }

      ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
        &:hover {
          border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
        }
      }
    `}
`

export const Label = styled.label`
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-bottom: 0.3rem;
`

export const ErrorMessageInfo = styled.p<StyledProps>`
  position: relative;
  padding: 0 1.2rem 0 0.5rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.error.background} !important;
  letter-spacing: 0;
  transition: opacity 0.2s;
  opacity: ${(p) => (p.$show ? "1" : "0")};
  margin: 0;
`

export const Description = styled.span`
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.3rem;
  margin: 0.6rem 0;
  display: block;
`

export const Error = styled(Description)`
  color: ${(p) => p.theme.colors.error.background};
`

export const FallbackValue = styled.div<FallbackProps>`
  margin-bottom: 1rem;
  line-height: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
`

export const FallbackTimeWrapper = styled.div`
  display: flex;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  width: fit-content;
`

export const FallBackDateTimeFrom = styled.div`
  background: ${(p) => p.theme.colors.turquoiseDarker};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  width: 16rem;
  position: relative;
  color: ${(p) => p.theme.colors.white};

  svg {
    height: 1.4rem;
    padding-right: 1rem;
    fill: ${(p) => p.theme.colors.white};
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const FallBackDateTimeTo = styled.div`
  background: ${(p) => p.theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  width: 16rem;
  position: relative;

  svg {
    height: 1.4rem;
    padding-right: 1rem;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const Date = styled.span`
  font-size: 1.1rem;
`

export const Time = styled.span`
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.6rem;
`

export const FallbackInputContainer = styled.div`
  margin-bottom: 2rem;
`

export const FallbackCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`

export const CheckboxIcon = styled.div`
  margin-left: 1rem;
  svg {
    fill: ${(p) => p.theme.colors.white};
    height: 1.8rem;
  }
`

export const CheckboxLabel = styled.div<FallbackProps>`
  align-items: center;
  margin-bottom: 1rem;
  background: ${(p) =>
    p.$booleanValue ? p.theme.colors.turquoiseDark : p.theme.colors.error.background};
  padding: 0.8rem;
  line-height: 1.6rem;
  display: flex;
  justify-content: space-between;
  border-radius: 0.6rem;
  width: fit-content;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: 700;
    font-size: 1.2rem;
    color: ${(p) => p.theme.colors.white};
  }

  span {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.2rem;
  }
`

export const FallbackMultiSelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: ${(p) => p.theme.colors.white};
  padding: 1rem 1rem 0 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  margin-bottom: 1rem;
  span {
    margin-right: 0.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    background: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
    padding: 0.2rem 1rem;
    margin-bottom: 1rem;
    border-radius: 0.6rem;
  }
`
